import { UnitcodeService } from '@gtpl/shared-services/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PalletsAdapter } from './dto/pallets.adapter';
import { PalletsController } from './pallets.controller';
import { PalletsRepository } from './pallets.repository';
import { PalletsService } from './pallets.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([PalletsRepository]),
  ],
  controllers: [PalletsController],
  providers: [PalletsService,PalletsAdapter, ApplicationExceptionHandler,UnitcodeService,LogsService]
})
export class PalletsModule {}
